import { EnumSurveyAnswerStatus } from "../../../Common/Enums/EnumsTypes";
import { CheckBoxPropsTypes } from "../CheckBoxPropsTypes";
import "../SCSS/stylesMobile.css";

function CheckBoxMobileView({
  handleMultiChange,
  questionObjVariable,
  questionId,
  surveyAnswers,
  isPreview,
  surveyAnswersInfo,
  handleChangeOtherOptionTextArea,
  othersOption,
}: CheckBoxPropsTypes) {
  return (
    <>
      {questionObjVariable?.[questionId]?.optionInfo?.optionOrder?.map(
        (optn) => {
          return (
            <div
              key={optn}
              className={`mobile-supplier-mobile-view-check-box-cover ${
                !surveyAnswers[questionId]?.val?.[optn]?.optionName
                  ? "mobile-supplier-mobile-view-check-box-cover"
                  : "mobile-supplier-mobile-view-check-box-cover-optionName"
              }`}
            >
              <input
                disabled={isPreview}
                type="checkbox"
                className="mobile-supplier-mobile-view-input-checkbox"
                onChange={(e) => {
                  surveyAnswersInfo?.surveyStatus !==
                    EnumSurveyAnswerStatus?.COMPLETED &&
                    handleMultiChange!(
                      e,
                      questionId,
                      optn,
                      questionObjVariable?.[questionId]?.optionInfo?.optionObj[
                        optn
                      ]?.optionName,
                      Number(
                        questionObjVariable?.[questionId]?.optionInfo
                          ?.optionObj[optn]?.weightage
                      )
                    );
                }}
                checked={
                  surveyAnswers[questionId]?.val?.[optn]?.optionId ?? false
                }
              />
              <label
                style={{
                  paddingLeft: "10px",
                  fontSize: "14px",
                  fontWeight: "400",
                }}
              >
                {
                  questionObjVariable?.[questionId]?.optionInfo?.optionObj?.[
                    optn
                  ]?.optionName
                }
              </label>
            </div>
          );
        }
      )}
      {surveyAnswers?.[questionId]?.isOthersChecked && (
        <>
          <div className="mobile-supplier-view-check-box-enable-others-text-area-cover">
            <textarea
              className={`mobile-supplier-view-check-box-enable-others-text-area ${
                surveyAnswers[questionId].val[othersOption!.optionId]
                  .othersAnswer &&
                surveyAnswersInfo?.surveyStatus !==
                  EnumSurveyAnswerStatus?.COMPLETED
                  ? "blue"
                  : "gray"
              }`}
              onChange={(event) => {
                surveyAnswersInfo?.surveyStatus !==
                  EnumSurveyAnswerStatus?.COMPLETED &&
                  handleChangeOtherOptionTextArea!(
                    event,
                    othersOption!.optionId
                  );
              }}
              value={
                surveyAnswers[questionId].val[othersOption!.optionId]
                  .othersAnswer ?? ""
              }
              disabled={isPreview}
              placeholder="Please Specify"
            />
          </div>
          {surveyAnswers[questionId]?.isOthersChecked &&
            questionObjVariable?.[questionId].validation.mandatory
              .isMandatory &&
            !surveyAnswers[questionId].val[othersOption!.optionId]
              .othersAnswer && (
              <span className="other-option-enable-mobile">
                Please specify others once enabled.
              </span>
            )}
        </>
      )}
    </>
  );
}

export default CheckBoxMobileView;
